import React from 'react';
import { Flex, Text } from 'rebass/styled-components';
import { Input, InputFake } from '../../../../components/TextInput';
import { IBuilderCtrlViewProps } from '../types';

export const TextInputCtrl: React.FC<IBuilderCtrlViewProps> = ({ properties }) => {
  console.log('PP',{...(properties || {}).ctrlProps} )
  return (
    <>
      <Flex flexDirection={'column'} flex={1 / 4}>
        <Text onClick={() => { }} fontWeight={500}>
          {`${(properties || {}).question || 'Question'}${((properties || {}).ctrlProps || {}).required ? '*' : ''}`}
        </Text>
        <Text fontSize={'12px'} fontWeight={300}>
          {(properties || {}).description || ''}
        </Text>
      </Flex>
      <InputFake {...(properties || {}).ctrlProps} type={((properties || {}).ctrlProps || {} as any).type==='email'?'text':''} style={{ height: 'fit-content' }} />
    </>
  );
};
